export default {
    myEntity: state => state.myEntity, // entity/me/
    isAuthenticated: state => state.isAuthenticated,
    hasSetup2FA: state => state.myEntity.has_setup_2fa,
    blockchainizeState: state => state.blockchainizeState,
    isNetworkFailure: state => state.isNetworkFailure,
    isNotAuthenticated: state => state.isNotAuthenticated
};
